import { create } from "zustand";
import { Agency } from "../interfaces/Agency";

type AgenciaStore = {
  agencia: Agency | null;
  /**
   * `true` mientras no se resuelve la primera lectura de `agencia/default`.
   * Evita confundir "aún no cargado" con "servicio suspendido".
   */
  loading: boolean;
  setAgencia: (agencia: Agency | null) => void;
  setLoading: (loading: boolean) => void;
  clearAgencia: () => void;
};

export const useAgenciaStore = create<AgenciaStore>((set) => ({
  agencia: null,
  loading: true,
  setAgencia: (agencia: Agency | null) => set({ agencia, loading: false }),
  setLoading: (loading: boolean) => set({ loading }),
  clearAgencia: () => set({ agencia: null, loading: true }),
}));
